var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "products_in" },
    [
      _c("div", { staticClass: "button_add mb-4" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
            on: {
              click: function ($event) {
                return _vm.add_prod()
              },
            },
          },
          [
            _c("span", { staticClass: "fal fa-eject mr-1" }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.__t("SELECT_PRODUCT")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-2" }, [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "bolt_rest" } },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.__t("SPECIAL_PRODUCTS")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        this.special_products.length > 0
          ? _c(
              "div",
              {},
              _vm._l(this.special_products, function (prod) {
                return _c("div", { staticClass: "special_items card p-2" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row align-items-center p-2" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "position-absolute remove",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.remove_item(prod)
                            },
                          },
                        },
                        [_vm._m(0, true)]
                      ),
                      _vm._v(" "),
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-3" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(prod.product_code + " | Price:" + prod.price)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n                        " +
                            _vm._s(prod.title) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.labels.length > 0
                    ? _c(
                        "div",
                        { staticClass: "d-block" },
                        [
                          _c(
                            "v-select",
                            {
                              staticClass: "imc_reasons",
                              attrs: {
                                reduce: function (label) {
                                  return label.type
                                },
                                label: "txt",
                                multiple: "",
                                options: _vm.labels,
                                filterable: false,
                              },
                              on: { input: _vm.work_labels },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "option",
                                    fn: function (option) {
                                      return [
                                        _c("div", { staticClass: "d-center" }, [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(option.txt) +
                                              "\n                            "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: prod.labels,
                                callback: function ($$v) {
                                  _vm.$set(prod, "labels", $$v)
                                },
                                expression: "prod.labels",
                              },
                            },
                            [
                              _c("template", { slot: "no-options" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.__t("LABELS")) +
                                    "\n                        "
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("product_modal_list", {
        attrs: {
          selected_ids: _vm.special_ids,
          is_multiple: true,
          show_trigger: "show_spec",
          push_trigger_list: "on_spec_list_selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "btn btn-danger btn-sm btn-icon waves-effect waves-themed",
      },
      [_c("i", { staticClass: "fal fa-times" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass:
          "fas fa-address-book icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }